// @flow
import React from 'react';
import Button from 'app/common/react/components/growth/unauth/Button/Button';
import i18n from 'app/common/lib/i18n';
import { Box } from 'gestalt';

const styles = {
  loginButton: {
    display: 'inline-block',
    marginTop: '0px',
    fontSize: '14px',
    padding: '0px',
    width: '128px',
    height: '40px',
    borderRadius: '4px',
    verticalAlign: 'middle',
  },
  mobileButton: {
    width: '92px',
  },
  loginButtonPulsar: {
    animationDuration: '2.5s',
    animationIterationCount: 'infinite',
    position: 'absolute',
    borderRadius: '9px',
    borderWidth: '4px',
    borderColor: 'rgb(74, 144, 226)',
    borderStyle: 'solid',
    pointerEvents: 'none',
    width: '130px',
    height: '42px',
  },
};

type Props = {
  containerStyles?: { [string]: string | number | void },
  colorClass?: string,
  numServerRenderedPins: number,
  onClick: (e: Event) => void,
};

export default function LoginButton(props: Props) {
  return (
    <Box
      data-test-id="loginButton"
      position="relative"
      dangerouslySetInlineStyle={{ __style: props.containerStyles || {} }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Button
        className={(props.colorClass || 'lightGrey') + ' headerLoginButton'}
        numServerRenderedPins={props.numServerRenderedPins}
        onClick={props.onClick}
        styleOverrides={{
          ...styles.loginButton,
        }}
      >
        {i18n._('Log in')}
      </Button>
    </Box>
  );
}
